module.exports = __webpack_public_path__ + "dashboard/img/dashboard.634b55c9ea413d2f9961ca744815410b.svg";